import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { getComponentRoutes } from './componentRouter' 

export const router = createBrowserRouter(getComponentRoutes())

export const RoutingProvider = () => {
  return <RouterProvider router={router} />
}